import { createAction, props } from '@ngrx/store';
import { IToolbarNotificationsResponse } from '../models/toolbar-notifications.model';

export const loadToolbarNotifications = createAction('[ToolbarNotification] Load ToolbarNotifications');

export const loadToolbarNotificationsSuccess = createAction(
  '[ToolbarNotification] Load ToolbarNotifications Success',
  props<{ response: IToolbarNotificationsResponse }>()
);

export const loadToolbarNotificationsFailure = createAction(
  '[ToolbarNotification] Load ToolbarNotifications Failure',
  props<{ error: Error | any }>()
);
